var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRentacademyMark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46777 8.59682C-0.822594 11.8983 -0.82259 17.251 2.46778 20.5525L24.5938 42.753C24.8283 43.0651 25.0872 43.3646 25.3706 43.6489L31.4708 49.7696C34.7611 53.0711 40.0959 53.0711 43.3862 49.7696L72.006 21.0534C75.2964 17.752 75.2964 12.3992 72.006 9.09778L65.9058 2.97705C62.6154 -0.324406 57.2807 -0.324401 53.9903 2.97705L37.4865 19.5365L20.4834 2.47609C17.1931 -0.825365 11.8583 -0.825363 8.56795 2.47609L2.46777 8.59682Z",
    fill: "url(#paint0_linear_5168_432)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 7.5786,
    y: 20.049,
    width: 59.0957,
    height: 59.257
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.81px)",
      clipPath: "url(#bgblur_0_5168_432_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_5168_432)",
    "data-figma-bg-blur-radius": 5.62648
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.1265,
    cy: 49.6775,
    rx: 23.9214,
    ry: 24.002,
    fill: "#BCE4F1",
    fillOpacity: 0.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1438 38.4611L33.1157 44.678L26.2676 45.6596C25.0563 45.8466 24.5905 47.3423 25.4756 48.2305L30.3671 53.045L29.2025 59.8228C29.0161 61.0381 30.3206 61.973 31.392 61.4121L37.4948 58.1868L43.5511 61.4121C44.6225 61.973 45.927 61.0381 45.7406 59.8228L44.576 53.045L49.4675 48.2305C50.3526 47.3423 49.8868 45.8466 48.6755 45.6596L41.874 44.678L38.7993 38.4611C38.2868 37.386 36.7029 37.3393 36.1438 38.4611Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_5168_432",
    x: 7.5786,
    y: 20.049,
    width: 59.0957,
    height: 59.257,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.281324,
    dy: 0.140662
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.70331
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5168_432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5168_432_clip_path",
    transform: "translate(-7.5786 -20.049)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.1265,
    cy: 49.6775,
    rx: 23.9214,
    ry: 24.002
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5168_432",
    x1: 37.2369,
    y1: 0,
    x2: 37.2369,
    y2: 52.2457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentacademyMark);
export default __webpack_public_path__ + "static/media/rentacademy_mark.54588b74a1c8b341d2f00d755db93fa5.svg";
export { ForwardRef as ReactComponent };